module.exports = __webpack_public_path__ + "images/kymcob9d7a7aacb332fa9d38a041d633bd99c.png";